// @flow @jsx h

import { h, Component } from 'preact'
import { debounce } from '../../../lib/debounce'

type Props = {
  children: any,
  class?: string
}

type State = {
  height: number
}

class Fullscreen extends Component<Props, State> {
  state = {
    height: 0
  }
  debouncedResize = null

  componentDidMount = () => {
    this.setState({ height: window.innerHeight })
    this.debouncedResize = debounce(this.onResize, 16.666)
    window.addEventListener('resize', this.debouncedResize)
  }
  componentWillUnmount = () => {
    window.addEventListener('resize', this.debouncedResize)
  }
  onResize = () => {
    this.setState({ height: window.innerHeight })
  }

  render() {
    return (
      <div class={this.props.class || ''} style={{ height: this.state.height }}>
        {this.props.children}
      </div>
    )
  }
}

export { Fullscreen }



// WEBPACK FOOTER //
// ./src/v1/components/lib/Fullscreen.js